import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import CheckoutValidator from '../../../common/validation/CheckoutValidator';
import SignupHeader from '../../SignupHeader/SignupHeader';
import AboutYou from '../AboutYou/AboutYou';
import AccountPassword from '../AccountPassword/AccountPassword';
import PreferredConnectionDate from '../PreferredConnectionDate/PreferredConnectionDate';
import ConnectionDateContainer from '../../../redux/containers/ConnectionDateContainer';
import CurrentConnectionContainer from '../../../redux/containers/CurrentConnectionContainer';
import ModemDeliveryContainer from '../../../redux/containers/ModemDeliveryContainer';
import CheckoutButtonContainer from '../../../redux/containers/CheckoutButtonContainer';
import TermsAndConditionsContainer from '../../../redux/containers/TermsAndConditionsContainer';
import handleSubmitFail from '../SubmitFailHandler';
import CheckoutFormInitialValues from './CheckoutFormInitialValues';

const OpenTermCheckout = props =>
  <main>
    <SignupHeader />
    <form>
      <AboutYou />
      <AccountPassword />
      <PreferredConnectionDate />
      <ConnectionDateContainer isSignUpJourney />
      <CurrentConnectionContainer />
      {!props.isByoModemSelected && <ModemDeliveryContainer />}
      <TermsAndConditionsContainer />
      <CheckoutButtonContainer {...props} />
    </form>
  </main>
;

OpenTermCheckout.propTypes = {
  isByoModemSelected: PropTypes.bool
};

export default reduxForm({
  form: 'checkout',
  destroyOnUnmount: false, // preserves the form data
  forceUnregisterOnUnmount: true,
  validate: CheckoutValidator,
  initialValues: CheckoutFormInitialValues,
  onSubmitFail: err => handleSubmitFail(err)
})(OpenTermCheckout);



/** WEBPACK FOOTER **
 ** ./src/components/checkout/Checkout/OpenTermCheckout.js
 **/